module.exports = __webpack_public_path__ + "static/img/zgdx.da0b103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zgdx.png
// module id = 40PF
// module chunks = 4